import { render, staticRenderFns } from "./AlliboJobList.vue?vue&type=template&id=5475ff82&scoped=true"
import script from "./AlliboJobList.vue?vue&type=script&lang=js"
export * from "./AlliboJobList.vue?vue&type=script&lang=js"
import style0 from "./AlliboJobList.vue?vue&type=style&index=0&id=5475ff82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475ff82",
  null
  
)

export default component.exports